import axios from 'axios';

const baseURL = window?.appConfig?.REACT_APP_API_GATEWAY || process.env.REACT_APP_API_GATEWAY;
const axiosClient = axios.create({
    baseURL: `${baseURL}/api/`,
});

export const createArticle = (data) => {
    return axiosClient.post('articles', data)
};

export const getArticles = (params) => {
    return axiosClient.get('articles' + params);
};

export const getArticleReferences = (articleId) => {
    return axiosClient.get(`articles/${articleId}`);
};